import { defineComponent as _defineComponent } from 'vue'
interface Props {
	top: string
	left: string
	radius: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'packageDetalisPopUp',
  props: {
    top: { default: "30px" },
    left: { default: "30px" },
    radius: { default: "5px" }
  },
  setup(__props: any) {

const props = __props as { top: string, left: string, radius: string };



return { __sfc: true,props }
}

})